export default __webpack_public_path__ + "static/media/analytics.e63ea164.svg";